// extracted by mini-css-extract-plugin
export default {"soldOutLabel":"_0uR9k","container":"_9OiIW"};